import { cx } from '@7f-ui'

export interface SeparatorProps {
  className?: string
  fullWidth?: boolean
  onlyMobile?: boolean
  text?: string
}

export function Separator({ className, fullWidth = false, onlyMobile, text }: SeparatorProps) {
  if (text) {
    return (
      <div className={cx(!fullWidth && 'fluid-container', 'flex items-center gap-4')}>
        <div className={cx('flex-1 border-primary/15 border-t', onlyMobile && 'sm:border-none')} />
        <span className="px-8 font-body-small">{text}</span>
        <div className={cx('flex-1 border-primary/15 border-t', onlyMobile && 'sm:border-none')} />
      </div>
    )
  }

  return (
    <div className={cx(!fullWidth && 'fluid-container')}>
      <div
        className={cx('border-primary/15 border-t', onlyMobile && 'sm:border-none', className)}
      />
    </div>
  )
}
